import { connect } from 'react-redux'
import requestChangeCardList from '../../sagas/requestChangeCardList'
import listSelector from './listSelector'
import List from './List'
import { withCardContext } from 'dataProviders/Card'

export default withCardContext(connect(
  listSelector,
  {
    requestChangeCardList
  }
)(List))
